export const document = {
  render: 'Document',
  children: ['paragraph', 'tag', 'list', 'fence'],
  attributes: {
  }
};
